import { render, staticRenderFns } from "./LaudoRelatorioTerritorial.vue?vue&type=template&id=ded7308e&scoped=true&lang=pug"
import script from "./LaudoRelatorioTerritorial.vue?vue&type=script&lang=js"
export * from "./LaudoRelatorioTerritorial.vue?vue&type=script&lang=js"
import style0 from "./LaudoRelatorioTerritorial.vue?vue&type=style&index=0&id=ded7308e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded7308e",
  null
  
)

export default component.exports